<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 :md4="isSplitView">
        <v-layout justify-center wrap>
          <v-flex xs12>
            <br/>
            <v-row justify="space-around">
              <v-btn
                color="primary"
                elevation="2"
                raised
                rounded
                small
                @click="showReport(0)"
              >Monthly Report</v-btn>
              <v-btn
                color="primary"
                elevation="2"
                raised
                rounded
                small
                @click="showReport(1)"
              >Yearly Report</v-btn>
              <v-btn
                color="primary"
                elevation="2"
                raised
                rounded
                small
                @click="showReport(2)"
              >FY Report</v-btn>
              <v-btn
                color="primary"
                elevation="2"
                raised
                rounded
                small
                @click="showOtherReport()"
              >Other Reports</v-btn>
            </v-row>
            <br/>
            <v-divider></v-divider>
            <br/>
            <div v-if="showOtherReports">
              <v-select
                :items="otherReportsItems"
                item-text="value"
                item-value="key"
                v-model="activeOtherReport"
                label="Other Reports"
                @change="showOtherReport()"
              ></v-select>
              <br/>
            </div>
            <CategoryReportTable
              class="mb-5 mr-5"
              navColor="rgb(107, 120, 219)"
              @rowClick="onSelected"
              :title="activeFilter.title"
              :filters="activeFilter.filters"
              :selectedItemKey="selectedItemKey"
            ></CategoryReportTable>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="isSplitView">
        <div>
          <div>
            <v-btn color="success" class="mr-4" @click="closeSplitView">Close</v-btn>
          </div>
          <br/>
          <v-divider></v-divider>
          <br/>
          <transaction-list
            :filter="selectedFilter"
          ></transaction-list>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
</template>
<script>
import moment from 'moment'
import ReportBox from "@/components/ReportBox"
import CategoryReportTable from "@/components/CategoryReportTable"
import TransactionList from "@/components/TransactionList"
import { TransactionFilter } from "@/models/transaction"
export default {
  components: {
    ReportBox,
    CategoryReportTable,
    TransactionList
  },
  data () {
    const thisMonth = moment().startOf('month')
    const thisYear = moment().startOf('year')
    const prevYear = thisYear.clone().add(-1, 'y')
    const thisFy = moment().month() > 2
      ? moment().startOf('year').add(3, 'M')
      : moment().startOf('year').add(-1, 'y').add(3, 'M')
    const prevFyYear = thisFy.clone().add(-1, 'y')

    const months = (new Array(6).fill(null)).map((_, i) => thisMonth.clone().add(-1 * i, 'M'))
    const years = (new Array(5).fill(null)).map((_, i) => thisYear.clone().add(-1 * i, 'y'))
    const fys = (new Array(5).fill(null)).map((_, i) => thisFy.clone().add(-1 * i, 'y'))
    const currentYearMonths = (new Array(12).fill(null)).map((_, i) => thisYear.clone().add(i, 'M'))
    const prevYearMonths = (new Array(12).fill(null)).map((_, i) => prevYear.clone().add(i, 'M'))
    const currentFyMonths = (new Array(12).fill(null)).map((_, i) => thisFy.clone().add(i, 'M'))
    const prevFyMonths = (new Array(12).fill(null)).map((_, i) => prevFyYear.clone().add(i, 'M'))

    const format = 'YYYY-MM-DD'
    const filters = [
      {
        title: `Last ${months.length} months`,
        filters: months.map((month) => {
          return new TransactionFilter({
            only_reportable: true,
            title: month.format('MMM'),
            start: month.format(format),
            end: month.clone().add(1, 'M').add(-1, 'm').format(format)
          })
        })
      },
      {
        title: `Last ${years.length} years`,
        filters: years.map((year) => {
          return new TransactionFilter({
            only_reportable: true,
            title: year.format('YYYY'),
            start: year.format(format),
            end: year.clone().add(1, 'Y').add(-1, 'm').format(format)
          })
        })
      },
      {
        title: `Last ${fys.length} FY`,
        filters: fys.map((year) => {
          return new TransactionFilter({
            only_reportable: true,
            title: `FY ${year.format('YY')} - ${year.clone().add(1, 'y').format('YY')}`,
            start: year.format(format),
            end: year.clone().add(1, 'Y').add(-1, 'm').format(format)
          })
        })
      }
    ]

    const createOtherReportConfig = (months, title) => {
      return {
        title,
        filters: months.map((month) => {
          return new TransactionFilter({
            only_reportable: true,
            title: month.format('MMM \'YY'),
            start: month.format(format),
            end: month.clone().add(1, 'M').add(-1, 'm').format(format)
          })
        })
      }
    }

    const otherReports = {
      'currentYear': createOtherReportConfig(currentYearMonths, `This year monthly`),
      'prevYear': createOtherReportConfig(prevYearMonths, `Last year monthly`),
      'currentFy': createOtherReportConfig(currentFyMonths, `FY monthly`),
      'prevFy': createOtherReportConfig(prevFyMonths, `Last FY monthly`)
    }

    const otherReportsItems = Object.keys(otherReports).map((key) => {
      return {
        key,
        value: otherReports[key].title
      }
    })

    return {
      isSplitView: false,
      activeFilter: filters[0],

      filters,
      otherReports,
      otherReportsItems,
      activeOtherReport: 'currentYear',
      showOtherReports: false,
      selectedFilter: new TransactionFilter(),
      selectedItemKey: null
    }
  },

  methods: {

    showReport (index) {
      this.activeFilter = this.filters[index]
      this.showOtherReports = false
    },
    showOtherReport (key) {
      this.showOtherReports = true
      if (key) {
        this.activeOtherReport = key
      }
      this.activeFilter = this.otherReports[this.activeOtherReport]
    },
    onSelected (item, filter, key) {
      this.selectedItemKey = key
      this.isSplitView = true
      let newFilter = filter.clone()
      newFilter.category = item.category.key
      this.selectedFilter.update(newFilter)
    },

    closeSplitView () {
      this.selectedItemKey = null
      this.isSplitView = false
    }
  },
}
</script>
